import { Outlet } from 'react-router-dom';
import Sidebar from '../components/chat/Sidebar';
import { useState } from 'react';
import Burger from '../components/chat/Burger';

const Chat = () => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <div className="flex w-screen h-screen overflow-x-hidden ">
      <div
        className={`SidebarMenu  fixed z-[100] h-screen ${
          isOpen ? 'isOpen' : ''
        }`}
      >
        <div>
          <Burger isOpen={isOpen} setIsOpen={setIsOpen} />
        </div>
        <Sidebar isOpen={isOpen} setIsOpen={setIsOpen} />
      </div>
      <div
        className={`flex flex-col flex-1 justify-between h-full md:p-6  pTransition ${
          isOpen ? 'pl-80' : 'md:pl-0'
        }`}
      >
        <Outlet />
      </div>
    </div>
  );
};

export default Chat;
